(function () {
  'use strict';

  var PROVINCE_SELECTOR =
    'select#province_country_field.rsi-select-field, select#province.rsi-select-field';
  var CITY_SELECTOR =
    'select#city_country_field.rsi-select-field, select#city.rsi-select-field';
  var POSTAL_SELECTOR =
    'select#zip_code_country_field.rsi-select-field, select#zip_code.rsi-select-field';
  var CITY_FIELD_SELECTOR =
    CITY_SELECTOR +
    ', input#city_country_field.rsi-text-input-field, input#city.rsi-text-input-field';
  var POSTAL_FIELD_SELECTOR =
    POSTAL_SELECTOR +
    ', input#zip_code_country_field.rsi-text-input-field, input#zip_code.rsi-text-input-field';
  var SEARCH_ID = 'pidelo-zip-search';
  var instanceCount = 0;

  function values(select) {
    return Array.from(select.options)
      .map(function (option) {
        return option.value.trim();
      })
      .filter(Boolean);
  }

  function availablePostalCodes(select) {
    return values(select).filter(function (value) {
      return /^\d{5}$/.test(value);
    });
  }

  function dispatchSelection(select, value) {
    if (select.value === value) return;
    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setDisabled(select, disabled) {
    if (!select || select.disabled === disabled) return;
    select.disabled = disabled;
    select.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  function fieldScope(field) {
    return field.closest('form') || document;
  }

  function syncDependencies(scope) {
    var province = scope.querySelector(PROVINCE_SELECTOR);
    var cityField = scope.querySelector(CITY_FIELD_SELECTOR);
    var postalCodeField = scope.querySelector(POSTAL_FIELD_SELECTOR);
    var city = cityField && cityField.matches(CITY_SELECTOR) ? cityField : null;
    var postalCode =
      postalCodeField && postalCodeField.matches(POSTAL_SELECTOR)
        ? postalCodeField
        : null;
    var cityReady = Boolean(province && province.value && city && values(city).length);
    var postalCodeReady = Boolean(
      cityReady && city.value && postalCode && availablePostalCodes(postalCode).length,
    );

    setDisabled(cityField, !cityReady);
    setDisabled(postalCodeField, !postalCodeReady);

    if (postalCode && postalCode.pideloSyncPostalSearch) {
      postalCode.pideloSyncPostalSearch();
    }
  }

  function syncAllDependencies() {
    document.querySelectorAll(POSTAL_FIELD_SELECTOR).forEach(function (field) {
      syncDependencies(fieldScope(field));
    });
  }

  function enhance(select) {
    if (select.dataset.pideloPostalSearch === 'true') return;
    var wrapper = select.closest('.rsi-select-wrapper');
    var row = select.closest('.rsi-select-input-row');
    if (!wrapper || !row) return;
    var scope = fieldScope(select);

    select.dataset.pideloPostalSearch = 'true';
    wrapper.classList.add('pidelo-postal-search');

    instanceCount += 1;
    var searchId = SEARCH_ID + '-' + instanceCount;

    var input = document.createElement('input');
    input.id = searchId;
    input.className = 'pidelo-postal-search__input';
    input.type = 'text';
    input.inputMode = 'numeric';
    input.autocomplete = 'postal-code';
    input.maxLength = 5;
    input.placeholder = '00000';
    input.setAttribute('aria-describedby', searchId + '-status');
    input.setAttribute('aria-invalid', 'false');

    var status = document.createElement('span');
    status.id = searchId + '-status';
    status.className = 'pidelo-postal-search__status';
    status.setAttribute('aria-live', 'polite');

    row.insertBefore(input, select);
    row.insertAdjacentElement('afterend', status);

    var lastCityValue = '';
    var preserveInvalidInput = false;

    function setStatus(state, message) {
      input.setAttribute('aria-invalid', state === 'error' ? 'true' : 'false');
      input.dataset.state = state;
      status.dataset.state = state;
      if (status.textContent !== message) status.textContent = message;
    }

    function syncOptions() {
      var city = scope.querySelector(CITY_SELECTOR);
      var cityValue = city ? city.value : '';
      var cityChanged = cityValue !== lastCityValue;
      var postalCodes = availablePostalCodes(select);
      var ready = Boolean(cityValue && postalCodes.length);

      lastCityValue = cityValue;

      input.disabled = !ready;
      input.placeholder = ready ? '00000' : 'Selecciona una Ciudad';

      if (ready && select.value && postalCodes.includes(select.value)) {
        preserveInvalidInput = false;
        input.value = select.value;
        setStatus('valid', 'CP válido.');
      } else if (!ready || cityChanged || !preserveInvalidInput) {
        preserveInvalidInput = false;
        input.value = '';
        dispatchSelection(select, '');
        setStatus('idle', '');
      }

      var label = wrapper.querySelector('label[for="' + select.id + '"]');
      if (label) label.htmlFor = searchId;
    }

    input.addEventListener('input', function () {
      input.value = input.value.replace(/\D/g, '').slice(0, 5);
      var postalCodes = availablePostalCodes(select);
      var selectedValue = postalCodes.includes(input.value) ? input.value : '';

      preserveInvalidInput = Boolean(input.value && !selectedValue);
      dispatchSelection(select, selectedValue);

      if (selectedValue) {
        setStatus('valid', 'CP válido.');
      } else if (input.value.length === 5) {
        setStatus('error', 'Este CP no pertenece a la Ciudad seleccionada.');
      } else {
        setStatus('idle', '');
      }
    });

    input.addEventListener('blur', function () {
      if (input.value && input.value.length < 5) {
        setStatus('error', 'Ingresa los 5 dígitos del código postal.');
      }
    });

    select.pideloSyncPostalSearch = syncOptions;
    syncOptions();
  }

  function scan(root) {
    if (root instanceof Element && root.matches(POSTAL_SELECTOR)) enhance(root);
    if (root.querySelectorAll) root.querySelectorAll(POSTAL_SELECTOR).forEach(enhance);
  }

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node instanceof Element) scan(node);
      });
    });
    syncAllDependencies();
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('change', function (event) {
    if (!(event.target instanceof Element)) return;
    var scope = fieldScope(event.target);
    if (event.target.matches(PROVINCE_SELECTOR)) {
      setDisabled(scope.querySelector(CITY_FIELD_SELECTOR), true);
      setDisabled(scope.querySelector(POSTAL_FIELD_SELECTOR), true);
    } else if (event.target.matches(CITY_SELECTOR)) {
      setDisabled(scope.querySelector(POSTAL_FIELD_SELECTOR), true);
    } else {
      return;
    }
    window.setTimeout(function () {
      syncDependencies(scope);
    }, 0);
  });

  scan(document);
  syncAllDependencies();
})();
